import { useEffect, useState } from "react";

const PremiumGames = () => {
    const [games, setGames] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch("https://api.allorigins.win/get?url=https://tajigames.com/api/api.php?type=gameList")
            .then((res) => res.json())
            .then((data) => {
                try {
                    const parsedData = JSON.parse(data.contents); // Parse JSON inside "contents"
                    setGames(parsedData.games || []); // Ensure games is an array
                } catch (error) {
                    console.error("Error parsing JSON:", error);
                    setGames([]);
                }
                setLoading(false);
            })
            .catch((err) => {
                console.error("Error fetching games:", err);
                setGames([]);
                setLoading(false);
            });
    }, []);

    if (loading) {
        return <p className="text-center text-white">Loading premium games...</p>;
    }

    return (
        <div className="grid gap-4 mt-8 sm:mt-12 lg:mt-24 sm:ms-10 md:ms-20 lg:ms-60 sm:me-4 md:me-8 lg:me-16" >
            <h1 className='text-black dark:text-white font-bold text-[24px]'>Premium Games</h1>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 me-50px py-200px">
                {games.length > 0 ? (
                    games.map((game, index) => (
                        <a
                            key={index}
                            href={game.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="bg-white dark:bg-gray-800 rounded-[10px] overflow-hidden shadow-xl cursor-pointer transition-transform transform hover:scale-105"
                        >
                            <div className="overflow-hidden w-full h-40 flex justify-center items-center bg-gray-200 dark:bg-gray-700 py-10 relative w-full sm:w-40 md:w-32 lg:w-40 aspect-square">
                                <img
                                    src={game.icon}
                                    alt={game.title}
                                    className="absolute inset-0 w-full h-full object-cover"
                                />
                            </div>
                            <div className="p-2">
                                <p className="text-sm md:text-base font-bold text-center truncate dark:text-white">
                                    {game.title}
                                </p>
                            </div>
                        </a>
                    ))
                ) : (
                    <p className="text-center text-white">No premium games available.</p>
                )}
            </div>
        </div>
    );
};

export default PremiumGames;
